import {
  USER_DOCUMENT_NONE,
  USER_DOCUMENT_PENDING,
  USER_DOCUMENT_APPROVED,
  USER_DOCUMENT_DECLINED,
} from "../constants/user";

export default {
  setUser,
  getUser,
  isModel,
  updateUser,
  isNotVerified,
  isPendingVerification,
  isDocumentVerificationApproved,
  isDocumentVerificationDeclined,
};

function setUser(user) {
  localStorage.setItem("user", JSON.stringify(user));
}

function getUser() {
  return JSON.parse(localStorage.getItem("user"));
}

function updateUser(payload) {
  localStorage.setItem(
    "user",
    JSON.stringify({
      ...getUser(),
      ...payload,
    })
  );
}

export function isEmailVerified() {
  const payload = getUser();
  return payload ? payload.is_email_verified : false;
}

export function getDocumentVerificationStatus() {
  const payload = getUser();
  return payload ? payload.is_document_verified : false;
}

export function isModel() {
  const user = getUser();
  return user ? user.user_type === 1 : false;
}

export function isRegularUser() {
  const user = getUser();
  return user ? user.user_type === 0 : false;
}

export function is2FAEnabled() {
  const user = getUser();
  return user ? user.phone_2fa_enabled : false;
}

export function isNotVerified() {
  const user = getUser();
  return user ? user.is_document_verified === USER_DOCUMENT_NONE : false;
}

export function isPendingVerification() {
  const user = getUser();
  return user ? user.is_document_verified === USER_DOCUMENT_PENDING : false;
}

export function isDocumentVerificationApproved() {
  const user = getUser();
  return user ? user.is_document_verified === USER_DOCUMENT_APPROVED : false;
}

export function isDocumentVerificationDeclined() {
  const user = getUser();
  return user ? user.is_document_verified === USER_DOCUMENT_DECLINED : false;
}

export function getUserId() {
  const user = getUser();
  return user?.id;
}

export function getEmail() {
  return getUser()?.email;
}

export function getUsername() {
  return getUser()?.username;
}

export function getDisplayname() {
  return getUser()?.name || getUser()?.username;
}

export function getUserUnqiueId() {
  return getUser()?.unique_id;
}

export function getPhoneNumber() {
  return getUser()?.mobile;
}

export function getPicture() {
  return getUser()?.picture;
}
